/* eslint-disable import-x/no-namespace */

import { FastFilterGroup } from '@vlabs/monokit/shared/ui/fast-filter-group';

import { STATUS_LABEL_KEYS } from './constants';
import * as fastFilters from './fast-filters';
import { useSourceFilters } from './useSourceFilters';

export function SourceFastFilters(): JSX.Element | null {
  const { filters, updateFilters } = useSourceFilters();
  const hasAppliedFilters = (filters.statuses?.length ?? 0) > 0
    || (filters.names?.length ?? 0) > 0
    || !!filters.reference;

  if (!hasAppliedFilters) return null;

  return (
    <FastFilterGroup>
      {(filters.statuses?.length ?? 0) > 0 && (
        <fastFilters.StatusFilterWithBottomPopover
          onClear={() => updateFilters({ statuses: undefined, page: 1 })}
          value={filters.statuses?.map((s) => String(STATUS_LABEL_KEYS[s])) as string[]}
        />
      )}
      {(filters.names?.length ?? 0) > 0 && (
        <fastFilters.SourceFilterWithBottomPopover
          onClear={() => updateFilters({ names: undefined, page: 1 })}
          value={filters.names?.join(', ') ?? ''}
        />
      )}
      {!!filters.reference && (
        <fastFilters.ReferenceFilterWithBottomPopover
          onClear={() => updateFilters({ reference: undefined, page: 1 })}
          value={filters.reference}
        />
      )}
    </FastFilterGroup>
  );
}
